// extracted by mini-css-extract-plugin
module.exports =  {"cooldown":"Emt75IwSRuuT11M3siep","cooldownElement":"Inn0qsBjUeqYX2ZVnTYA"};